<div #printSection>
  <div class="p-4 mt-4 mb-4" style="background-color: rgba(244, 244, 244, 1)">
    <div class="row">
      <div class="col-3">
        <strong>Total de Vagas Confirmadas:</strong>
        <strong style="color: rgba(12, 50, 111, 1)">
          {{ totalVagasConfirmadas }}</strong
        >
      </div>
      @for (resumo of resumoVagas; track resumo.modalidade; let i = $index) {
        <div class="col-3">
          {{ resumo.modalidade }}:
          <strong style="color: rgba(12, 50, 111, 1)"
            >{{ resumo.total }}
          </strong>
        </div>
        {{ i < resumoVagas.length - 1 ? " | " : "" }}
      }
    </div>
  </div>

  @for (item of data; track item.modalidadeId) {
    <div class="table-container mb-4">
      <app-table-filter-bar [title]="item.modalidade" [showSearch]="false">
      </app-table-filter-bar>

      <table class="table-result">
        <thead>
          <tr>
            <th scope="col">Vagas</th>
            <th scope="col">INE</th>
            <th scope="col">Nome da Equipe INE</th>
            <th scope="col">Tipo da Equipe</th>
            <th scope="col">CNES</th>
            <th scope="col">Nome do Estabelecimento</th>
          </tr>
        </thead>
        <tbody>
          @for (
            value of item.pages[item.currentPage - 1].data;
            track value.id;
            let i = $index
          ) {
            <tr>
              <td>{{ i + 1 }}</td>
              <td>{{ value.vagaCicloIne?.nuIne || "Não informado" }}</td>
              <td>{{ value.vagaCicloIne?.nomeEquipe || "-" }}</td>
              <td>{{ value.vagaCicloIne?.tipoEquipe?.nome || value.vagaCiclo?.vagaPrograma?.tipoEquipe?.nome || "-" }}</td>
              <td>{{ value.vagaCicloIne?.coCnes || "-" }}</td>
              <td>{{ value.vagaCicloIne?.nomeEstabelecimento || "-" }}</td>
            </tr>
          }
        </tbody>
      </table>
      <!--app-pagination
      [total]="item.total"
      [page]="item.currentPage"
      [pageSize]="item.pageSize"
      [exibir]="[2]"
      (onSelectPage)="item.currentPage = $event"
      (onSelectPageSize)="item.pageSize = $event"
    >
    </app-pagination-->
    </div>
  }
</div>
<hr />

<div class="d-flex justify-content-between">
  <br-button
    [emphasis]="'secondary'"
    [isLoading]="isSubmitting"
    (click)="prev()"
    [ariaLabel]="'Voltar'"
  >
    Voltar
  </br-button>

  <div class="d-flex justify-content-between">
    @if (!confirmacaoVaga.rascunho) {
      <br-button
        [emphasis]="'secondary'"
        (click)="print()"
        [ariaLabel]="'Imprimir'"
      >
        <i class="fa fa-print"></i>
        Imprimir
      </br-button>
    }
    @if (isPeriodoVigenteForEnable()) {
      <br-button
        [emphasis]="'primary'"
        class="ml-2"
        [isLoading]="isSubmitting"
        (click)="confirm()"
        [ariaLabel]="'Confirmar Vagas'"
        >Confirmar Vagas</br-button
      >
    }
  </div>
</div>
